'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _components = require('./components/');

var _components2 = _interopRequireDefault(_components);

var _services = require('./services/');

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.creditRequest.shared', [_components2.default.name, _services2.default.name]);


// WEBPACK FOOTER //
// ./src/credit-request/shared/index.js